import { ColDef, ICellRendererParams } from "ag-grid-community";
import { ResourceType } from "@/services/cloudchipr.api";
import { resourceAccountColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/resourceAccountColumnDef";
import { columnDefsMap } from "@/components/pages/common/resources-ag-grid/components/column-defs/columnDefsMap";
import { tagsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/tagsColumnDef";
import { ResourceGridCleanDialogGridIdentifierCellRenderer } from "@/components/pages/common/resources-ag-grid/components/resource-clean/clean-dialog/components/content/grid/ResourceGridCleanDialogGridIdentifierCellRenderer";
import { readDataByDotSeparatedString } from "@/components/pages/common/ag-grid/utils/helpers/readDataByDotSeparatedString";

export const getCleanDialogGridColumnDefs = (
  resourceType: ResourceType,
): ColDef[] => {
  const resourceColumnDefs = columnDefsMap.get(resourceType);
  const firstCell = resourceColumnDefs?.at(0);

  if (!firstCell) {
    return [];
  }

  const columns: ColDef[] = [
    {
      ...firstCell,
      cellRenderer: ({ data, column }: ICellRendererParams) => {
        const value = readDataByDotSeparatedString(
          column?.getColDef().field ?? "",
          data,
        );

        return (
          <ResourceGridCleanDialogGridIdentifierCellRenderer
            name={value}
            lockIconMessage={data.resource?.protected_by}
          />
        );
      },
    },
    resourceAccountColumnDef,
  ];

  const hasTag = resourceColumnDefs?.find(
    (column) => column.field === tagsColumnDef.field,
  );

  if (hasTag) {
    columns.push(tagsColumnDef);
  }

  return columns;
};
